import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { fetchShouldDisplayResetPasswordAfterLogin } from "@faire/retailer-visitor-shared/components/AppSignIn/useShouldDisplayResetPasswordAfterLogin";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import qs from "query-string";
export var initializeResetPasswordModal = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(history) {
        var shouldShowModal;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchShouldDisplayResetPasswordAfterLogin()
                    ];
                case 1:
                    shouldShowModal = _state.sent();
                    if (shouldShowModal && isLoggedInRetailer()) {
                        //TODO: add event tracking
                        history.replace(_object_spread_props(_object_spread({}, history.location), {
                            search: qs.stringify(_object_spread_props(_object_spread({}, qs.parse(history.location.search)), {
                                resetPassword: 1
                            }))
                        }));
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function initializeResetPasswordModal(history) {
        return _ref.apply(this, arguments);
    };
}();
